export class PortfolioDTO {
    public id?: number;
    public businessId!: string;
    public name!: string;
    public propertyIdList:number[]=[];
    public history?:string;
    public added?:string;
    public edited?:string;
    public addedByUser?:string;
    public lastEditedByUser!:string;
}